import Vapi from '@borisp/vuex-rest-api'
import { payloadToState, getOptimisticDelete } from 'utils/helpers'
import { VUE_APP_BASE_API_URL }  from '../../constants/fileConstants'

const users = new Vapi({
  baseURL: VUE_APP_BASE_API_URL,
  state: {
    users: [],
    user: {}
  }
})
  .get({
    action: 'getUsers',
    property: 'users',
    path: '/users/',
    onSuccess: payloadToState('users')
  })
  .post({
    action: 'createUser',
    property: 'user',
    path: '/users/',
    onSuccess: payloadToState('user')
  })
  .get({
    action: 'getUser',
    property: 'user',
    path: ({ id }) => `/users/${id}`,
    onSuccess: payloadToState('user')
  })
  .put({
    action: 'updateUser',
    property: 'user',
    path: ({ id }) => `/users/${id}`,
    onSuccess: payloadToState('user')
  })
  .delete({
    action: 'deleteUser',
    property: 'user',
    path: ({ id }) => `/users/${id}`,
    beforeRequest: getOptimisticDelete('users'),
    onSuccess: payloadToState('user')
  })
  .getStore()

export default users
